import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { Container, Row, Col } from "../Grid"
import Snippet from "../Snippet"

import { media, mixins } from "../../styles"

const Wrapper = styled.div``

const Photo = styled.div`
  margin: auto 0 60px;

  /* @media ${media.lg} {
    margin: 0;
  }

  @media ${media.lg} {
    margin: 0 0 0 auto;
    max-width: 436px;
  }

  @media ${media.xl} {
    max-width: 617px;
  } */
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media ${media.md} {
    padding: 0 15px;
  }

  @media ${media.xl} {
    padding: 0 30px;
  }

  h2 {
    ${mixins.title4}
  }

  p {
    ${mixins.copy4}
  }
`

const AboutUs = () => {
  const data = useStaticQuery(graphql`
    query AboutUsQuery {
      whoWeAreImage: file(
        relativePath: { eq: "content/careers/who-we-are.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 517, height: 339, layout: CONSTRAINED)
        }
      }
      whatWeDoImage: file(
        relativePath: { eq: "content/careers/what-we-do.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 517, height: 339, layout: CONSTRAINED)
        }
      }
    }
  `)

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col md="6" lg="5" lgOffset="1">
            <Content>
              <h2>
                <Snippet id="careersWhoWeAre" field="header" />
              </h2>
              <Snippet id="careersWhoWeAre" field="text" md />
              <Photo>
                <GatsbyImage
                  alt={Snippet({ id: "careersWhoWeAre", field: "header" })}
                  image={data.whoWeAreImage.childImageSharp.gatsbyImageData}
                />
              </Photo>
            </Content>
          </Col>
          <Col md="6" lg="5">
            <Content>
              <h2>
                <Snippet id="careersWhatWeDo" field="header" />
              </h2>
              <Snippet id="careersWhatWeDo" field="text" md />
              <Photo>
                <GatsbyImage
                  alt={Snippet({ id: "careersWhatWeDo", field: "header" })}
                  image={data.whatWeDoImage.childImageSharp.gatsbyImageData}
                />
              </Photo>
            </Content>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default AboutUs
